<template>
  <el-main>
    <SelectForm @search="searchList" ref="search_form" :form_style="form_search_style" :form="form"></SelectForm>
    <div class="btns_rows">
      <el-button size="small" type="primary" @click="add_car_dialog = true">新增</el-button>
      <!-- <el-button size="small" type="primary">批量导入</el-button> -->
    </div>
    <TableCommon :data="data_config.list" :table_config="table_config">
      <template #source="{ row }">
        {{ row.store_user_id == 0 ? '平台' : '门店' }}
      </template>
      <template #shops_name="{ row }">
        {{ row.shops_id ? row.shops_name : '--' }}
      </template>
      <template #wxwork_user_info="{ row }">
        <div v-if="!row.wxwork_user_id"></div>
        <div v-else class="wxwork_user_info">
          {{ row.wxwork_user_info.alias }}
          <br />
          {{ row.wxwork_user_info.nickName }}
        </div>
      </template>
      <template #car_info="{ row }">
        <UserInfo :avatar="row.product_image_url" :name="row.product_name" :square="true"></UserInfo>
      </template>
      <template #item_cate_id="{ row }">
        {{ cate_info.hash[row.item_cate_id] || '--' }}
      </template>
      <template #price="{ row }">
        <div v-if="is_supplier">
          <div>结算价:{{ row.settlement_price }}</div>
        </div>
        <div v-if="!is_supplier">
          <div>零售价:{{ row.price }}</div>
          <div>同行价:{{ row.original_price }}</div>
          <div>租赁价:{{ row.rent_price }}</div>
          <div>同行租赁价:{{ row.peer_price }}</div>
          <div v-if="row.is_pre == 1">预售价:{{ row.price }}</div>
          <div v-if="row.is_pre == 0 && row.status == 'ONLINESALL'">预售价:{{ row.price }}</div>
        </div>
      </template>
      <template #mode="{ row }">
        {{ sale_mode_hash[row.sales_model] || '' }}
      </template>
      <template #is_recommend="{ row }">
        <el-switch v-model="row.is_recommend" active-color="#13ce66" inactive-color="#ff4949" disabled :active-value="1"
          :inactive-value="0"></el-switch>
      </template>
      <template #user_profile_info="{ row }">
        {{ row.user_profile_info ? row.user_profile_info.name : '--' }}
      </template>
      <template #item_update_record="{ row }">
        {{ row.item_update_record.id ? row.item_update_record.name : '--' }}
      </template>
      <template #status="{ row }">
        {{ car_status_hash[row.status] || '--' }}
      </template>
      <template #cz="{ row }">
        <div class="cz">
          <el-button type="text" @click="viewCar(row)">查看</el-button>
          <el-button type="text" @click="editCar(row)">编辑</el-button>
        </div>
      </template>
    </TableCommon>
    <Paging :total="data_config.total_number" :page="data_config.page" :pageNum="data_config.rows"
      @updatePageNum="tableDataConfigChange"></Paging>

    <!-- 添加车辆弹窗 -->
    <!-- <el-dialog title="新增" :visible.sync="add_car_dialog" width="700px">
      <template>
        <div class="car_category">
          <div @click="toAddCar(category)" v-for="category in car_type_info.list.slice(1)" :key="category.id" class="category">
            <div class="img_box">
              <el-image :src="category.icon_url" style="width: 100%"></el-image>
            </div>
            <div class="category_title">{{ category.name }}</div>
          </div>
        </div>
      </template>
    </el-dialog> -->

    <!-- 添加车辆弹窗V3 -->
    <el-dialog title="新增车辆" :visible.sync="add_car_dialog" width="700px">
      <div class="car_form_v3">
        <div class="top_title">
          <div class="parent">产品分类</div>
          <div class="son">产品子类</div>
        </div>
        <div class="bottom_list">
          <div class="parent">
            <div :class="['p_category', now_choose_first_category_id == item.id ? 'p_category_active' : '' ]"
              @click="chooseFirstCategory(item)" v-for="item in categorysV3" :key="item.id">
              <img class="category_icon" :src="item.icon_picture" alt="">
              {{ item.name }}
            </div>
          </div>
          <div class="son">
            <div class="s_category_box">
              <div :class="['s_category', now_choose_second_category_id == item.id ? 's_category_active' : '' ]"
                @click="chooseSecondCategory(item)" v-for="item in now_choose_first_category._child" :key="item.id">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="add_car_dialog = false">取 消</el-button>
        <el-button type="primary" @click="toAddCar()">确 定</el-button>
      </span>
    </el-dialog>
  </el-main>
</template>

<script>
import SelectForm from '@/components/selecForm.vue';
import TableCommon from '@/components/table.vue';
import common_data from '@/util/common_data.js';
import { getDateformat } from '@/util/getDate.js';
import UserInfo from '@/components/userInfo.vue';
import _ from 'lodash';

export default {
  components: {
    SelectForm,
    TableCommon,
    UserInfo,
  },
  data() {
    return {
      getDateformat,
      supplier_type: common_data.supplier_type,
      form_search_style: common_data.form_search_style,
      header_cell_style: common_data.header_cell_style,
      form: [
        {
          key: 'cate_id',
          label: '车辆类别',
          type: 'select',
          placeholder: '请选择',
          list: [],
          d_value: 0,
        },
        {
          key: 'category_id',
          label: '车辆类型',
          type: 'select',
          placeholder: '请选择',
          list: [],
          d_value: 0,
        },
        {
          key: 'address',
          label: '位置',
          type: 'cascader',
          placeholder: '请选择',
          list: [],
          config: {
            children: '_child',
            label: 'name',
            value: 'id',
            multiple: true,
            checkStrictly: true,
          },
          d_value: '',
        },
        {
          key: 'status',
          label: '状态',
          type: 'select',
          placeholder: '请选择',
          list: [],
          config: { label: 'description', value: 'dict_value' },
          d_value: '',
        },
        {
          key: 'sales_model',
          label: '销售模式',
          type: 'select',
          placeholder: '请选择',
          list: [],
          config: { label: 'description', value: 'dict_value' },
          d_value: '',
        },
        {
          key: 'create_time',
          label: '创建日期',
          type: 'datetimerange',
          placeholder: '请选择',
          d_value: '',
        },
      ],
      cate_info: {
        list: [{ id: 0, name: '全部' }],
        hash: {},
      },
      car_type_info: {
        list: [{ id: 0, name: '全部' }],
        hash: {},
      },
      car_status_hash: {},
      sale_mode_hash: {},
      supplier_config: {
        page: 1,
        rows: 20,
        is_more: true,
        product_name: '',
      },
      shops_config: {
        page: 1,
        rows: 20,
        is_more: true,
        product_name: '',
      },
      data_config: {
        page: 1,
        rows: 10,
        list: [],
        total_number: 0,
      },
      table_config: [
        { key: 'item_cate_id', label: '车辆类别', type: 'slot' },
        { key: 'classify_name', label: '车辆类型', type: 'text' },
        { key: 'car_info', label: '车辆信息', type: 'slot', width: '200px' },
        { key: 'price', label: '价格', type: 'slot', width: '200px' },
        { key: 'mode', label: '模式', type: 'slot' },
        { key: 'status', label: '状态', type: 'slot', width: '120px' },
        { key: 'location', label: '位置', width: '200px', type: 'text' },
        { key: 'create_time', label: '创建时间', type: 'time', width: '200px' },
        { key: 'update_time', label: '更新时间', type: 'time', width: '200px' },
        {
          key: 'cz',
          label: '操作',
          type: 'slot',
          fixed: 'right',
          width: '150px',
        },
      ],
      add_car_dialog: false,
      is_supplier: false,
      categorysV3: [],
      now_choose_first_category_id: 0,
      now_choose_second_category_id: 0,
    };
  },
  computed: {
    now_choose_first_category() {
      return this.categorysV3.find((item) => item.id == this.now_choose_first_category_id) || { _child: [] }
    },
    now_choose_second_category() {
      return this.now_choose_first_category._child.find((item) => item.id == this.now_choose_second_category_id) || { _child: [] }
    },
  },
  methods: {
    chooseFirstCategory(first) {
      this.now_choose_first_category_id = first.id
      this.now_choose_second_category_id = 0
      this.getV3Categorys(first.id, first)
    },
    chooseSecondCategory(second) {
      this.now_choose_second_category_id = second.id
    },
    // 获取新车辆分类列表
    getV3Categorys(new_category_id, category) {
      let obj = {}
      if (new_category_id) {
        obj.new_category_id = new_category_id
        obj.level = 2
      }
      this.$axios.post(this.$api.chache.getNewCategorys, obj).then((res) => {
        if (res.code === 0) {
          if (!new_category_id) {
            this.categorysV3 = res.result.new_category_list.list
            this.chooseFirstCategory(this.categorysV3[0])
          } else {
            this.$set(category, '_child', res.result.new_category_list.list)
          }
        }
      })
    },
    getCateList() {
      this.$axios
        .post(this.$api.chache.cate_list, {
          is_car: 1,
        })
        .then((res) => {
          if (res.code === 0) {
            this.cate_info.list.push(...res.result);
            this.cate_info.list.forEach((item) => {
              this.$set(this.cate_info.hash, item.id, item.name);
            });
            this.form[0].list = this.cate_info.list;
          }
        });
    },
    getCarTypeList() {
      this.$axios
        .post(this.$api.chache.category_list, {
          is_add: 1,
        })
        .then((res) => {
          if (res.code === 0) {
            this.car_type_info.list.push(...res.result.list);
            this.car_type_info.list.forEach((item) => {
              this.$set(this.car_type_info.hash, item.id, item.name);
            });
            this.form[1].list = this.car_type_info.list;
          }
        });
    },
    getSearchForm() {
      this.$axios.post(this.$api.chache.carAttributeList).then((res) => {
        if (res.code == 0) {
          res.result.forEach((item, index) => {
            item.attribute_value.unshift({ id: '-1', option_name: '全部' });
            let obj = {
              key: '_attribute' + index,
              label: item.attribute_name,
              type: 'select',
              placeholder: '请选择',
              list: item.attribute_value,
              d_value: '-1',
              config: {
                label: 'option_name',
              },
            };
            this.form.splice(2 + index, 0, obj);
          });
        }
      });
    },
    getAreaList() {
      this.$axios.get(this.$api.set.area + '?tree=1&level=1').then((res) => {
        if (res.code == 0) {
          let data = this.form.find((item) => item.key == 'address');
          this.$set(data, 'list', res.result.list);
        }
      });
    },
    searchList(params) {
      this.data_config.page = 1;
      this.getTableCarList();
    },
    getTableCarList() {
      let obj = {
        page: this.data_config.page,
        rows: this.data_config.rows,
      };
      if (this.$refs.search_form) obj = { ...obj, ...this.$refs.search_form.deal() };

      obj.attribute_value_ids = [];
      for (const key in obj) {
        if (key.indexOf('_attribute') === 0) {
          if (obj[key] !== '-1') {
            obj.attribute_value_ids.push(obj[key]);
            delete obj[key];
          }
        }
        if (key === 'location' && obj[key]) {
          obj.province_id = obj[key].map((item) => (item.length === 1 ? item[0] : '')).filter((i) => i);
          obj.city_id = obj[key].map((item) => (item.length === 2 ? item[1] : '')).filter((i) => i);
          delete obj[key];
        }
      }
      this.$axios.post(this.$api.chache.car_new_list, obj).then((res) => {
        if (res.code === 0) {
          res.result.list.forEach((item) => {
            this.$set(item, 'visible', false);
            this.$set(item, 'is_choose', false);
            item.new_attribute_contents.forEach((attr) => {
              item[`${attr.attribute_id}`] = attr.option_name;
            });
          });
          this.data_config.list = res.result.list;
          this.data_config.total_number = res.result.total_number;
        }
      });
    },
    getTableHeader() {
      this.$axios.post(this.$api.chache.carHeaderAttributeList).then((res) => {
        if (res.code == 0) {
          let attr_list = [];
          for (let i = 0; i < res.result.length; i++) {
            let attr = res.result[i];
            attr_list.push({
              key: String(attr.attribute_id),
              label: attr.attribute_name,
              type: 'text',
            });
          }
          this.table_config.splice(2, 0, ...attr_list);
        }
      });
    },
    tableDataConfigChange(val, status) {
      if (status == 0) {
        this.data_config.rows = val;
        this.data_config.page = 1;
      } else {
        this.data_config.page = val;
      }
      this.getTableCarList();
    },
    // 跳转到新增车辆页面
    toAddCar(category) {
       if(!this.now_choose_second_category_id){
        this.$message.warning("请选择产品分类")
        return
      }
      if(category)this.$router.push({ path: '/chache/addCar', query: { c: category.id } })
      if(!category){
        this.$router.push({ path: '/chache/addCar', query: { c: this.now_choose_second_category.category_id,f:this.now_choose_first_category_id,n:this.now_choose_second_category_id } })
      }
    },
    editCar(car) {
      this.$router.push({ path: '/chache/editCar', query: { c: car.category_id, car: car.id } });
    },
    viewCar(car) {
      this.$router.push({ path: '/chache/infoCar', query: { c: car.category_id, car: car.id } });
    },
  },
  created() {
    this.is_supplier = this.$store.dispatch('user/isSupplier');
    // 获取新版本分类
    this.getV3Categorys();
    this.getCateList();
    this.getCarTypeList();
    this.getSearchForm();
    this.getTableHeader();
    this.getAreaList();
    this.$store.dispatch('basic/getPayHash', { type: 'VEHICLESTATE' }).then((res) => {
      let data = this.form.find((item) => item.key == 'status');
      res.forEach((item) => {
        this.$set(this.car_status_hash, item.dict_value, item.description);
      });
      this.$set(data, 'list', res);
    });
    this.$store.dispatch('basic/getPayHash', { type: 'SALESMODEL' }).then((res) => {
      let data = this.form.find((item) => item.key == 'sales_model');
      res.forEach((item) => {
        this.$set(this.sale_mode_hash, item.dict_value, item.description);
      });
      this.$set(data, 'list', res);
    });
    this.getTableCarList();
  },
};
</script>

<style lang="less" scoped>
.el-main {
  background: #fff;
  min-height: 100%;
}
.btns_rows {
  display: flex;
  justify-content: flex-end;
  padding: 10px 0;
}
.wxwork_user_info {
  width: 100%;
  text-align: center;
}
.show_all_data_box {
  display: flex;
  .show_error_box,
  .show_success_box {
    flex: 1;
    height: 100%;
    .title {
      font-size: 16px;
      font-weight: bold;
      color: #f56c6c;
      padding: 10px 0;
    }
  }
  .show_error_box {
    padding-right: 12px;
  }
  .show_success_box {
    padding-left: 12px;
    .title {
      color: #67c23a;
    }
  }
}
.car_category {
  display: flex;
  justify-content: space-around;
  width: 100%;
  .category {
    padding-top: 20px;
    width: 30%;
    padding-bottom: 30px;
    flex-shrink: 0;
    border: 1px solid #ebeef5;
    display: flex;
    flex-direction: column;
    align-items: center;
    .img_box {
      width: 196px;
      height: 156px;
    }
    .category_title {
      font-size: 20px;
      font-weight: bold;
      margin-top: 20px;
    }
    &:hover {
      cursor: pointer;
      border-color: #409eff;
      background-color: rgba(64, 158, 255, 0.1);
    }
  }
}

.car_form_v3 {
  width: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid #ebeef5;
  & > div {
    display: flex;
    & > div {
      display: flex;
      align-items: center;
      padding-left: 24px;
    }
    .parent {
      flex: 0 0 160px;
      border-right: 1px solid #ebeef5;
    }
    .son {
      flex: 1;
    }
  }
  .top_title {
    flex: 0 0 40px;
    font-size: 16px;
    font-weight: 500;
    border-bottom: 1px solid #ebeef5;
  }
  .bottom_list {
    flex: 0 0 400px;
    .parent {
      display: flex;
      flex-direction: column;
      padding: 0 6px;
      .p_category {
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;
        padding-left: 10px;
        font-size: 14px;
        cursor: pointer;
        border-radius: 4px;
        .category_icon {
          width: 30px;
          height: 30px;
        }
        &:hover {
          background-color: rgba(64, 158, 255, 0.1);
        }
      }
      .p_category_active {
        background-color: rgba(64, 158, 255, 0.1);
      }
    }
    .son {
      padding: 0 6px;
      align-items: flex-start;
      padding-top: 6px;
      .s_category_box {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 6px;
      }
      .s_category {
        height: 40px;
        display: flex;
        align-items: center;
        padding-left: 10px;
        font-size: 14px;
        cursor: pointer;
        border-radius: 4px;
        background-color: #f7f8fb;
        text-align: center;
        &:hover {
          background-color: rgba(64, 158, 255, 0.1);
        }
      }
      .s_category_active {
        background-color: rgba(64, 158, 255, 0.1);
      }
    }
  }
}
</style>
